import * as React from "react";
import { useTl, useApiService } from "../../../../hooks";
import { useParams, useHistory } from "react-router";
import { useApiEffect } from "nsitools-react";
import { PageBase, BackButton, ProtectedTabs } from "../../../../components";
import { ETLCodes } from "../../../../locales";
import { ERoutes } from "../../../../ERoutes";
import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import { CalendarYearDetailPage } from "./CalendarYearDetailPage";
import { CalendarYearApi } from "../../../../api";

export interface ICalendarYearItemPageProps {}

export const CalendarYearItemPage: React.FunctionComponent<ICalendarYearItemPageProps> = (props) => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const idCalendarYear = React.useMemo(() => +id, [id]);
  const history = useHistory();
  const calendarYearApi = useApiService(CalendarYearApi);
  const [displayName, loading] = useApiEffect(() => calendarYearApi.getDisplayName(idCalendarYear), [idCalendarYear]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.CalendarYear), route: ERoutes.calendarYear },
        { text: idCalendarYear > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsBreedGroups"
        onChange={(newTabId) => history.push(`${ERoutes.breedGroups}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.calendarYear} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<CalendarYearDetailPage calendarYearId={idCalendarYear} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
